
const ui = true;

//dynamic

// const live = window.location.origin.includes('localhost') ? false : true;
// const staging = window.location.origin.includes('temporary');

//live

const live = true; 
const staging = false;	  		


//local

// const live = false; 
// const staging = true;	

//staging

// const live = true 
// const staging = true	
 
if (live && !staging) {
	console.log = function () { }
}


let mobile = true


const baseUrl = window.location.origin

const apiUrl = live ?
	staging ?
		`https://j3sg4dfntrhkdasjvxymoyr7uu0drvzu.lambda-url.us-east-1.on.aws` // dev-staging	
		:
		// 'https://y74j6u4w7p35lv2qf3z3dicizm0dpces.lambda-url.us-east-1.on.aws' // live
		`https://ias6ndm7ms2viluebiae5usof40eerux.lambda-url.us-east-1.on.aws` // live - new version
	:
	'http://localhost:3000'; // local


let client = 'Ca14QMByyrJptpZArRyALMy9Qg2DySnx';
let audience = `https://bispoke.us.auth0.com/api/v2/`
let domain = `auth.bispoke.io`

let custom_plan = live ?
	staging ?
		"price_1RRkj72ZcRiEpBSP2DqvCsm2" //staging or dev plan
		:
		"price_1RS8JnFHHaw30K7HDmWCbTcj" //live plan
	:
	"price_1RRkj72ZcRiEpBSP2DqvCsm2" //staging or dev plan

if (staging) {
	client = 'nEBhH88sL6SZeY5Iuag9DYUfKd9teVW9';
	audience = `https://bispoke-dev.us.auth0.com/api/v2/`
	domain = `bispoke-dev.us.auth0.com`
}


const options = {
	domain: domain,
	clientID: client,
	redirectUri: baseUrl,
	responseType: 'token id_token',
	audience: audience,
	scope: "openid email profile"
};

const tableBigQuery = {
	product_ids_total: `bispoke-sidekick.product_info.product_ids_total`,
	product_edits_dev: `bispoke-sidekick.product_write_test.product_edits`,
	product_edits:     `bispoke-sidekick.product_write_prod.product_edits_prod` ,
	vw_products_dev: `bispoke-sidekick.product_info.vw_products_with_json_overrides`,
	vw_products_live: `bispoke-sidekick.product_info.vw_products_with_json_overrides_prod`,
	marketplace_year_goals_dev: `bispoke-sidekick.product_write_test.marketplace_year_goals`,
	marketplace_year_goals_live: `bispoke-sidekick.product_write_prod.marketplace_year_goals`
}

// console.log({ live, staging, baseUrl, apiUrl, options, })
if (!live || staging) console.log({ live, staging, baseUrl, apiUrl, options })

let webAuth = new window.auth0.WebAuth(options)
// let webAuth = {}

export { webAuth, baseUrl, ui, live, apiUrl, client, options, mobile, audience, domain, custom_plan , tableBigQuery, staging}


